import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";

const initialState = {} as IMonitoring;

const monitoringSlice = createSlice({
    name: "monitoring",
    initialState,
    reducers: {
        setMonitoring: (state, action: PayloadAction<IMonitoring>) => {
            Object.assign(state, action.payload);
        },
    },
});

export const { setMonitoring } = monitoringSlice.actions;
export default monitoringSlice.reducer;

export const getMonitoring = (state: RootState) => state.monitoring;
